import styles from "./ProductCard.module.css";

const ProductCard = ({ product, onClick }) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.imageContainer}>
        <img
          src={product.img_url}
          alt={product.app_name}
          className={styles.image}
        />
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{product.app_name}</h2>
        <p className={styles.description}>{product.description}</p>
      </div>
    </div>
  );
};

export default ProductCard;
